import { render } from "./AsideMenuItem.vue?vue&type=template&id=6e9141e8&scoped=true"
import script from "./AsideMenuItem.vue?vue&type=script&lang=js"
export * from "./AsideMenuItem.vue?vue&type=script&lang=js"

import "./AsideMenuItem.vue?vue&type=style&index=0&id=6e9141e8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/employer/employer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9141e8"]])

export default __exports__